/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SaveAssetPersonalDataClientPart
 */
export interface SaveAssetPersonalDataClientPart {
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    salutation: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    title: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    firstName: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    lastName: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    formerLastName: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    insuranceNumber: string | null;
    /**
     * 
     * @type {Date}
     * @memberof SaveAssetPersonalDataClientPart
     */
    birthday: Date | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    placeOfBirth: string | null;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    street: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    houseNumber: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    zipCode: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    country: string;
    /**
     * 
     * @type {string}
     * @memberof SaveAssetPersonalDataClientPart
     */
    employmentStatus: string | null;
}

/**
 * Check if a given object implements the SaveAssetPersonalDataClientPart interface.
 */
export function instanceOfSaveAssetPersonalDataClientPart(value: object): value is SaveAssetPersonalDataClientPart {
    if (!('salutation' in value) || value['salutation'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('firstName' in value) || value['firstName'] === undefined) return false;
    if (!('lastName' in value) || value['lastName'] === undefined) return false;
    if (!('formerLastName' in value) || value['formerLastName'] === undefined) return false;
    if (!('insuranceNumber' in value) || value['insuranceNumber'] === undefined) return false;
    if (!('birthday' in value) || value['birthday'] === undefined) return false;
    if (!('placeOfBirth' in value) || value['placeOfBirth'] === undefined) return false;
    if (!('street' in value) || value['street'] === undefined) return false;
    if (!('houseNumber' in value) || value['houseNumber'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('country' in value) || value['country'] === undefined) return false;
    if (!('employmentStatus' in value) || value['employmentStatus'] === undefined) return false;
    return true;
}

export function SaveAssetPersonalDataClientPartFromJSON(json: any): SaveAssetPersonalDataClientPart {
    return SaveAssetPersonalDataClientPartFromJSONTyped(json, false);
}

export function SaveAssetPersonalDataClientPartFromJSONTyped(json: any, ignoreDiscriminator: boolean): SaveAssetPersonalDataClientPart {
    if (json == null) {
        return json;
    }
    return {
        
        'salutation': json['salutation'],
        'title': json['title'],
        'firstName': json['firstName'],
        'lastName': json['lastName'],
        'formerLastName': json['formerLastName'],
        'insuranceNumber': json['insuranceNumber'],
        'birthday': (json['birthday'] == null ? null : new Date(json['birthday'])),
        'placeOfBirth': json['placeOfBirth'],
        'street': json['street'],
        'houseNumber': json['houseNumber'],
        'zipCode': json['zipCode'],
        'city': json['city'],
        'country': json['country'],
        'employmentStatus': json['employmentStatus'],
    };
}

export function SaveAssetPersonalDataClientPartToJSON(json: any): SaveAssetPersonalDataClientPart {
    return SaveAssetPersonalDataClientPartToJSONTyped(json, false);
}

export function SaveAssetPersonalDataClientPartToJSONTyped(value?: SaveAssetPersonalDataClientPart | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'salutation': value['salutation'],
        'title': value['title'],
        'firstName': value['firstName'],
        'lastName': value['lastName'],
        'formerLastName': value['formerLastName'],
        'insuranceNumber': value['insuranceNumber'],
        'birthday': value['birthday'] == null ? value['birthday'] : `${value['birthday'].getFullYear()}-${String(value['birthday'].getMonth()+1).padStart(2,'0')}-${String(value['birthday'].getDate()).padStart(2,'0')}`,
        'placeOfBirth': value['placeOfBirth'],
        'street': value['street'],
        'houseNumber': value['houseNumber'],
        'zipCode': value['zipCode'],
        'city': value['city'],
        'country': value['country'],
        'employmentStatus': value['employmentStatus'],
    };
}

